/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import ErrorView from '@/views/ErrorView';
import GetAllServiceBranches from '@/services/GetAllServiceBranches';
import GetAllRegions from '@/services/GetAllRegions';

import AddCommandPage from '../pages/AddCommandPage';

export default async function ShowAddCommandPage() {
  if(EXTERNAL) {
    showErrorView();
    return;
  }

  NProgress.start();
  const [serviceBranches, regions] = await Promise.all([GetAllServiceBranches(), GetAllRegions()]);
  NProgress.set(0.5);
  try {
    NavUtils.navigate(`new-command`);
    Scaffold.getRegion('content').show(
      new AddCommandPage({
        model: new Backbone.Model({ serviceBranches, regions })
      })
    );
  } catch(err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Add Command page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Add Command page.'
      })
    })
  );
}